import styled from "styled-components";
import PaxDetails from "./PaxDetails.styled";
import ChecklistResolutionStatus from "models/checklist/checklist-resolution-status";

interface Props {
  resolutionStatus: ChecklistResolutionStatus;
}

const PaxInfoContainer = styled.div<Props>`
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: center;
  box-shadow: ${({ theme }) => theme.shadows.card};
  padding: 21px;
  height: 100%;
  box-sizing: border-box;
  border-radius: ${({ theme }) => theme.borderRadiusJourney};

  ${PaxDetails} h5 {
    color: ${({ resolutionStatus, theme }) => {
      switch (resolutionStatus) {
        case ChecklistResolutionStatus.ActionRequired:
          return theme.colors.notResolvedChecklistStatus;
        case ChecklistResolutionStatus.ReadyToFly:
          return theme.colors.confirmation;
        default:
          return theme.colors.notResolvedChecklistStatus;
      }
    }};
  }
  }

  @media all and (max-width: ${({ theme }) => theme.mobileBreakingPoint}) {
    padding: 16px;
  }
`;

export default PaxInfoContainer;
